'use client';

import { useEffect, useState } from 'react';

// Keeps a conditionally-rendered node mounted while it plays its exit
// animation — the one job `AnimatePresence` did for us before framer-motion
// was removed (2026-08).
//
//   const { rendered, exiting } = usePresence(isOpen);
//   return rendered ? (
//     <div className={exiting ? 'anim-exit' : 'anim-enter'}>...</div>
//   ) : null;
//
// `exitMs` must match the `--exit-duration` used by the node's `anim-exit`
// class (both default to 200ms); a mismatch either cuts the animation short or
// leaves an invisible node mounted for the difference.
export const usePresence = (open: boolean, exitMs = 200) => {
  const [rendered, setRendered] = useState(open);

  // Adjusting state during render (React's documented pattern) rather than in
  // an Effect: mounting has to happen in this same render pass or the enter
  // animation misses its first frame and the node pops in.
  if (open && !rendered) setRendered(true);

  useEffect(() => {
    if (open) return;
    const timer = setTimeout(() => setRendered(false), exitMs);
    return () => clearTimeout(timer);
  }, [open, exitMs]);

  return { rendered, exiting: rendered && !open };
};

export default usePresence;
